(() => {
  if (window.mobileOverlayPanelInitialized) return;
  window.mobileOverlayPanelInitialized = true;

  let activeDialog = null;
  let opener = null;
  let previousOverflow = '';

  function restorePage(dialog) {
    if (dialog !== activeDialog) return;
    document.body.style.overflow = previousOverflow;
    activeDialog = null;
    if (opener?.isConnected) opener.focus();
    opener = null;
  }

  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    if (activeDialog) {
      const previousDialog = activeDialog;
      restorePage(previousDialog);
      previousDialog.close();
    }
    opener = trigger || document.activeElement;
    previousOverflow = document.body.style.overflow;
    dialog.showModal();
    activeDialog = dialog;
    document.body.style.overflow = 'hidden';
    dialog.querySelector('[data-mobile-overlay-close]')?.focus();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mobile-overlay-open]');
    if (trigger) {
      const key = trigger.dataset.mobileOverlayOpen;
      const dialog = Array.from(document.querySelectorAll('dialog[data-mobile-overlay]')).find((item) => item.dataset.mobileOverlay === key && key);
      openDialog(dialog, trigger);
      return;
    }
    const closeButton = event.target.closest('[data-mobile-overlay-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
    if (event.target.matches('dialog[data-mobile-overlay]')) event.target.close();
  });

  document.addEventListener('close', (event) => {
    restorePage(event.target);
  }, true);

  document.addEventListener('shopify:section:select', (event) => {
    const dialog = event.target.querySelector('dialog[data-mobile-overlay]');
    if (dialog) openDialog(dialog);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const dialog = event.target.closest('dialog[data-mobile-overlay]');
    if (dialog) openDialog(dialog);
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    const dialog = event.target.querySelector('dialog[data-mobile-overlay]');
    if (dialog?.open) dialog.close();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (activeDialog && event.target.contains(activeDialog)) {
      restorePage(activeDialog);
    }
  });
})();
